<app-navbar title="Pagamentos">
  @if (userHasPermission('create payments')) {
  <p-button (click)="openDialog()" pTooltip="Criar pagamento">
    <i class="fa-solid fa-plus"></i>
    <span class="font-bold hidden md:block">Criar pagamento</span>
  </p-button>
  }
</app-navbar>

<div class="py-8 px-4 space-y-4 overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)]">
  <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
    <app-payment-card [dayValue]="paymentTodayIndicators()?.expected_payments_today?.value | currency"
      [monthValue]="paymentTodayIndicators()?.expected_payments_month?.value | currency"
      descriptionLight="Pagamentos previstos" [loading]="loadingDashboard()" />
    <app-payment-card [dayValue]="paymentTodayIndicators()?.paid_today?.value | currency"
      [monthValue]="paymentTodayIndicators()?.paid_month?.value | currency" descriptionLight="Total pago"
      [loading]="loadingDashboard()" />
    <app-payment-card [dayValue]="paymentTodayIndicators()?.pending_payments_today?.value | currency"
      [monthValue]="paymentTodayIndicators()?.expected_payments_month?.value | currency"
      descriptionLight="Pagamentos pendentes" [loading]="loadingDashboard()" />
  </div>

  <div class="grid 2xl:grid-cols-2 grid-cols-1 gap-4">
    <div class="col-span-2 2xl:col-span-1 grid grid-cols-2 gap-4">
      <div class="col-span-2 lg:col-span-1">
        <app-card>
          <app-card-header title="Vencimentos" />
          @if (loadingDashboard()) {
          <p-skeleton class="mb-4" />
          <p-skeleton class="mb-4" />
          <p-skeleton class="mb-4" />
          <p-skeleton class="mb-4" />
          <p-skeleton class="mb-4" />
          <p-skeleton class="mb-4" />
          <p-skeleton class="mb-4" />
          <p-skeleton class="mb-4" />
          }
          @else {
          <div class="flex flex-col items-start justify-start gap-2">
            <div class="text-lg">Mês</div>
            <div class="w-full">
              <app-simple-horizontal-bar [data]="mountPaymentDueCurrentMonthMetrics()" />
            </div>
          </div>
          <p-divider />
          <div class="flex flex-col items-start justify-start gap-2">
            <div class="text-lg">Semana</div>
            <div class="w-full">
              <app-simple-horizontal-bar [data]="mountPaymentDueCurrentWeekMetrics()" />
            </div>
          </div>
          }
        </app-card>
      </div>
      <div class="col-span-2 lg:col-span-1">
        <app-card>
          <p-tabs value="0">
            <p-tablist>
              <p-tab value="0" class="text-sm p-1">Total de Pagamentos</p-tab>
              <p-tab value="1" class="text-sm p-1">Evolução dos Pagamentos</p-tab>
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel value="0">
                @if (loadingDashboard() && !totalPaymentMetricsChartData()) {
                <div class="flex flex-col items-center gap-4">
                  <p-skeleton shape="circle" size="19rem" />
                  <div class="flex items-center w-full gap-2">
                    <p-skeleton class="mb-4 w-16" />
                    <p-skeleton class="mb-4 w-16" />
                    <p-skeleton class="mb-4 w-16" />
                  </div>
                </div>
                } @else if (totalPaymentMetricsChartData()?.datasets.length) {
                <div class="relative w-76 h-76">
                  <p-chart type="doughnut" [data]="totalPaymentMetricsChartData()"
                    [options]="totalPaymentMetricsChartOptions()" class="w-full h-76" />
                  <div class="absolute top-24 left-1/2 -translate-x-1/2 text-center">
                    <div class="text-sm text-zinc-400">Total</div>
                    <div class="text-lg text-zinc-900 font-semibold">
                      {{ totalPaymentMetrics()?.total_payments?.value | currency }}
                    </div>
                  </div>
                </div>
                <div class="text-sm text-zinc-500 mt-4">
                  Total pendente de aprovação {{ totalPaymentMetrics()?.total_pending_approval?.value | currency }} ({{
                  totalPaymentMetrics()?.total_pending_approval?.count }})
                </div>
                } @else {
                <app-empty-chart />
                }
              </p-tabpanel>
              <p-tabpanel value="1">
                @if (loadingDashboard() && !paymentEvolutionChartData()) {
                <div class="w-full h-96 flex items-center justify-center">
                  <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s"
                    [style]="{ width: '50px', height: '50px' }" />
                </div>
                } @else if (paymentEvolutionChartData()?.datasets.length) {
                <p-chart type="bar" [data]="paymentEvolutionChartData()" [options]="paymentEvolutionChartOptions()"
                  class="w-full h-80" />
                } @else {
                <app-empty-chart />
                }
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </app-card>
      </div>
    </div>
    <div class="col-span-2 2xl:col-span-1 flex flex-col xl:flex-row gap-4">
      <div class="2xl:w-5/12 xl:w-4/12 w-full">
        <app-card>
          <app-card-header title="Pagamento por Categoria" />
          @if (loadingDashboard() && !paymentByCategoryChartData()) {
          <div class="flex flex-col items-center gap-4">
            <p-skeleton shape="circle" size="19rem" />
            <div class="flex items-center w-full gap-2">
              <p-skeleton class="mb-4 w-16" />
              <p-skeleton class="mb-4 w-16" />
              <p-skeleton class="mb-4 w-16" />
            </div>
          </div>
          } @else if (paymentByCategoryChartData()?.datasets.length) {
          <div class="xl:w-full w-80">
            <p-chart type="doughnut" [data]="paymentByCategoryChartData()" [options]="paymentByCategoryChartOptions()"
              class="w-full h-80" />
          </div>
          } @else {
          <app-empty-chart />
          }
        </app-card>
      </div>
      <div class="2xl:w-7/12 xl:w-8/12 w-full">
        <app-card>
          <app-card-header title="Top 10 Pagamentos do Mês" />
          <app-table-payments-top-five [loading]="loadingDashboard()" (edit)="openDialog($event)" />
        </app-card>
      </div>
    </div>
  </div>

  <app-card>
    <app-card-header title="Pagamentos">
      <form [formGroup]="paymentFiltersForm" class="flex flex-wrap items-center justify-end gap-2">
        <p-floatlabel variant="on" class="w-full sm:w-64">
          <p-select id="receiver_id" class="w-full" [options]="peopleList()" formControlName="people_id"
            optionLabel="name" [showClear]="true" optionValue="id" appendTo="body" multiple />
          <label for="receiver_id">Fornecedor/Prestador</label>
        </p-floatlabel>
        <p-floatlabel variant="on" class="w-full sm:w-40">
          <p-select id="category_id" class="w-full" [options]="categoryList()" formControlName="category_id"
            optionLabel="title" [showClear]="true" optionValue="id" appendTo="body" multiple />
          <label for="category_id">Categoria</label>
        </p-floatlabel>
        <p-floatlabel variant="on" class="w-full sm:w-40">
          <p-select id="status" class="w-full" [options]="paymentStatus | keyvalue" formControlName="status"
            optionLabel="value" [showClear]="true" optionValue="value" appendTo="body" multiple>
            <ng-template let-status #item>
              <div>{{ status.value | paymentStatus }}</div>
            </ng-template>
            <ng-template let-status #selectedItem>
              <div>{{ status.value | paymentStatus }}</div>
            </ng-template>
          </p-select>
          <label for="status">Status</label>
        </p-floatlabel>
        <p-floatlabel variant="on" class="w-full sm:w-64">
          <input fluid pInputText id="search_term" formControlName="search_term" autocomplete="off" />
          <label for="search_term">Buscar</label>
        </p-floatlabel>
        <p-inputgroup class="w-full sm:w-auto">
          <p-floatlabel variant="on" class="w-full sm:w-52">
            <p-datepicker id="date_range" dateFormat="dd/mm/yy" formControlName="date_range" selectionMode="range"
              [readonlyInput]="true" appendTo="body" fluid />
            <label for="date_range">Período</label>
          </p-floatlabel>
          <p-inputgroup-addon>
            <span class="text-sm text-zinc-500 w-auto">
              {{ dateField | paymentFilterDateField }}
            </span>
          </p-inputgroup-addon>
          <p-inputgroup-addon>
            <p-button variant="text" severity="secondary" type="button" (onClick)="op.toggle($event)">
              <i class="fa-solid fa-filter text-zinc-500"></i>
            </p-button>
            <p-popover #op>
              <div class="flex flex-col gap-4">
                <ul class="list-none p-0 m-0 flex flex-col">
                  @for (filter of paymentFilterDateField | keyvalue; track $index) {
                  <li class="flex items-center text-sm gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border"
                    (click)="paymentFiltersForm.patchValue({ date_field: filter.value }); op.hide()">
                    {{ filter.value | paymentFilterDateField }}
                  </li>
                  }
                </ul>
              </div>
            </p-popover>
          </p-inputgroup-addon>
        </p-inputgroup>
      </form>
    </app-card-header>
    <div class="w-full mt-8">
      <app-table-payments [loading]="loading() || loadingDashboard()"
        [search_term]="paymentFiltersForm.get('search_term')?.value"
        [date_range]="paymentFiltersForm.get('date_range')?.value"
        [date_field]="paymentFiltersForm.get('date_field')?.value"
        [category_id]="paymentFiltersForm.get('category_id')?.value"
        [people_id]="paymentFiltersForm.get('people_id')?.value" [status]="paymentFiltersForm.get('status')?.value"
        (edit)="openDialog($event)" />
    </div>
  </app-card>
</div>

<p-dialog [(visible)]="paymentDialog" [maximizable]="true" [modal]="true" [style]="{ width: '56rem' }"
  [closable]="true">
  <ng-template #header>
    <div class="w-full items-center justify-center">
      <h1 class="text-2xl text-zinc-900 font-bold">{{ paymentDialogTitle() }}</h1>
    </div>
  </ng-template>

  <form [formGroup]="paymentForm" class="grid grid-cols-2 gap-4">

    <div class="flex flex-col justify-start gap-1 col-span-2">
      <label for="receiver_id" class="font-semibold">Recebedor/Fornecedor</label>
      <p-select id="receiver_id" [options]="peopleList()" formControlName="receiver_id" optionLabel="name"
        [filter]="true" filterBy="name" [showClear]="true" placeholder="Escolha uma recebedor/fornecedor"
        optionValue="id" [invalid]="paymentForm.get('receiver_id')?.dirty && paymentForm.get('receiver_id')?.errors"
        appendTo="body" (onChange)="getContractList(paymentForm.get('receiver_id')?.value)" [disabled]="loading()"
        [virtualScroll]="true" [virtualScrollItemSize]="20">
        <ng-template let-people #item>
          <div>{{ people.name }}</div>
        </ng-template>
      </p-select>
      @if (paymentForm.get('receiver_id')?.dirty && paymentForm.get('receiver_id')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Selecione uma recebedor/fornecedor</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2">
      <label for="contract_id" class="font-semibold">Contrato</label>
      <p-select id="contract_id" [options]="contractList()" formControlName="contract_id" optionLabel="title"
        [filter]="true" filterBy="title" [showClear]="true" placeholder="Escolha um contrato" optionValue="id"
        [invalid]="paymentForm.get('contract_id')?.dirty && paymentForm.get('contract_id')?.errors" appendTo="body"
        [virtualScroll]="true" [virtualScrollItemSize]="20" [disabled]="loading()">
        <ng-template let-contract #item>
          <div>{{ contract.title }}</div>
        </ng-template>
      </p-select>
      @if (paymentForm.get('contract_id')?.dirty && paymentForm.get('contract_id')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Selecione um contrato</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
      <label for="category_id" class="font-semibold">Categoria</label>
      <p-select id="category_id" [options]="categoryList()" formControlName="category_id" optionLabel="title"
        [filter]="true" filterBy="title" [showClear]="true" placeholder="Escolha uma categoria" optionValue="id"
        [invalid]="paymentForm.get('category_id')?.dirty && paymentForm.get('category_id')?.errors" appendTo="body"
        (onChange)="getPaymentCategories(paymentForm.get('category_id')?.value)" [disabled]="loading()">
        <ng-template let-category #item>
          <div>{{ category.title }}</div>
        </ng-template>
      </p-select>
      @if (paymentForm.get('category_id')?.dirty && paymentForm.get('category_id')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Selecione uma categoria</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
      <label for="subcategory_id" class="font-semibold">Subcategoria</label>
      <p-select id="subcategory_id" [options]="subcategoryList()" formControlName="subcategory_id" optionLabel="title"
        [filter]="true" filterBy="title" [showClear]="true" placeholder="Escolha uma categoria" optionValue="id"
        [invalid]="paymentForm.get('subcategory_id')?.dirty && paymentForm.get('subcategory_id')?.errors"
        appendTo="body" [disabled]="loading()">
        <ng-template let-subcategory #item>
          <div>{{ subcategory.title }}</div>
        </ng-template>
      </p-select>
      @if (paymentForm.get('subcategory_id')?.dirty && paymentForm.get('subcategory_id')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Selecione uma categoria</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
      <label for="nfse_key" class="font-semibold">Documento</label>
      <input pInputText id="nfse_key" formControlName="nfse_key" fluid autocomplete="off"
        [invalid]="paymentForm.get('nfse_key')?.dirty && paymentForm.get('nfse_key')?.errors" [disabled]="loading()" />
      @if (paymentForm.get('nfse_key')?.dirty && paymentForm.get('nfse_key')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Documento é obrigatório</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
      <label for="title" class="font-semibold">Título</label>
      <input pInputText id="title" formControlName="title" fluid autocomplete="off"
        [invalid]="paymentForm.get('title')?.dirty && paymentForm.get('title')?.errors" [disabled]="loading()" />
      @if (paymentForm.get('title')?.dirty && paymentForm.get('title')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Título é obrigatório</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2">
      <label for="value" class="font-semibold">Valor</label>
      <p-inputnumber id="value" mode="currency" currency="BRL" locale="pt-BR" formControlName="value"
        [invalid]="paymentForm.get('value')?.dirty && paymentForm.get('value')?.errors" />
      @if (paymentForm.get('value')?.dirty && paymentForm.get('value')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Insira o valor do pagamento</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-1">
      <label for="issue_at" class="font-semibold">Data da Emissão</label>
      <p-datepicker formControlName="issue_at" dateFormat="dd/mm/yy" [iconDisplay]="'input'" [showIcon]="true"
        inputId="issue_at" appendTo="body" fluid
        [invalid]="paymentForm.get('issue_at')?.dirty && paymentForm.get('issue_at')?.errors" />
      @if (paymentForm.get('issue_at')?.dirty && paymentForm.get('issue_at')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Data da emissão é obrigatória</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-1">
      <label for="due_date" class="font-semibold">Data do Vencimento</label>
      <p-datepicker formControlName="due_date" dateFormat="dd/mm/yy" [iconDisplay]="'input'" [showIcon]="true"
        inputId="due_date" appendTo="body" fluid
        [invalid]="paymentForm.get('due_date')?.dirty && paymentForm.get('due_date')?.errors" />
      @if (paymentForm.get('due_date')?.dirty && paymentForm.get('due_date')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Data do vencimento é obrigatória</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2">
      <label for="doc" class="font-semibold">Documentos</label>
      @if (!paymentId) {
      <div
        class="w-full md:w-2/3 h-20 rounded border-2 border-dashed border-gray-400 flex flex-col items-center justify-center cursor-pointer transition-all"
        [ngClass]="{'border-gray-900': isDocumentDragging()}" (click)="doc.click()"
        (drop)="onDropFile($event, 'doc'); isDocumentDragging.set(false)"
        (dragover)="$event.preventDefault(); $event.stopPropagation(); isDocumentDragging.set(true)"
        (dragleave)="$event.preventDefault(); $event.stopPropagation(); isDocumentDragging.set(false)"
        (dragenter)="$event.preventDefault(); $event.stopPropagation(); isDocumentDragging.set(true)">
        <input id="doc" #doc type="file" multiple (change)="onFileSelected($event, 'doc')" class="hidden" />
        <div><i class="fa-solid fa-upload"></i></div>
        <span>
          Selecione ou arraste um documento ...
        </span>
      </div>
      }
      <div class="flex flex-col gap-2 w-2/3 mt-4">
        @for (doc of paymentDocs; track $index) {
        <div class="w-full border border-indigo-600 rounded flex items-center justify-between p-2 cursor-pointer"
          (click)="openDoc($index)">
          <span class="text-sm font-semibold">
            {{ doc.description || doc.name }}
          </span>
          <i class="fa-solid fa-xmark text-rose-600 ml-auto cursor-pointer" pTooltip="Remover"
            (click)="removeDoc($index); $event.stopPropagation()"></i>
        </div>
        }
      </div>
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2">
      <label for="invoice" class="font-semibold">Fatura</label>
      @if (!paymentId) {
      <div
        class="w-full md:w-2/3 h-20 rounded border-2 border-dashed border-gray-400 flex flex-col items-center justify-center cursor-pointer transition-all"
        [ngClass]="{
            'border-gray-900': isInvoiceDragging(),
            'border-red-600': paymentForm.get('invoice')?.dirty && paymentForm.get('invoice')?.errors
          }" (click)="invoice.click()" (drop)="onDropFile($event, 'invoice'); isInvoiceDragging.set(false)"
        (dragover)="$event.preventDefault(); $event.stopPropagation(); isInvoiceDragging.set(true)"
        (dragleave)="$event.preventDefault(); $event.stopPropagation(); isInvoiceDragging.set(false)"
        (dragenter)="$event.preventDefault(); $event.stopPropagation(); isInvoiceDragging.set(true)">
        <input id="invoice" #invoice type="file" (change)="onFileSelected($event, 'invoice')" class="hidden" />
        <div><i class="fa-solid fa-upload"></i></div>
        <span>
          Selecione ou arraste um documento ...
        </span>
      </div>
      }
      @if (paymentForm.get('invoice')?.dirty && paymentForm.get('invoice')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Fatura é obrigatória</p-message>
      }
      <div class="flex flex-col gap-2 w-2/3 mt-4">
        @if (paymentInvoice) {
        <div class="w-full border border-indigo-600 rounded flex items-center justify-between p-2 cursor-pointer"
          (click)="openInvoice()">
          <span class="text-sm font-semibold">
            {{ paymentInvoice?.name || 'Fatura' }}
          </span>
          <i class="fa-solid fa-xmark text-rose-600 ml-auto cursor-pointer" pTooltip="Remover"
            (click)="removeInvoice(); $event.stopPropagation()"></i>
        </div>
        }
      </div>
    </div>

    @if (isFromInvoice) {
    <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
      <label for="value" class="font-semibold">Valor total da fatura</label>
      <p-inputnumber id="value" mode="currency" currency="BRL" locale="pt-BR" formControlName="invoice_value" readonly />
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
      <label for="value" class="font-semibold">Valor em aberto</label>
      <p-inputnumber id="value" mode="currency" currency="BRL" locale="pt-BR" formControlName="invoice_pending_value" readonly />
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2">
      <label for="invoice_docs" class="font-semibold">Arquivos da Fatura</label>
      <div class="flex flex-col gap-2 w-2/3 mt-4">
        @for (invoiceDoc of invoiceDocs; track $index) {
        <div class="w-full border border-indigo-600 rounded flex items-center justify-between p-2 cursor-pointer"
          (click)="openInvoiceDoc($index)">
          <span class="text-sm font-semibold">
            {{ (invoiceDoc?.invoice_description ) ?? '' }}
          </span>
        </div>
        }
      </div>
    </div>
    }

    <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
      <label for="reference_month" class="font-semibold">Competência</label>
      <p-input-mask id="reference_month" formControlName="reference_month" fluid autocomplete="off"
        [invalid]="paymentForm.get('reference_month')?.dirty && paymentForm.get('reference_month')?.errors"
        [disabled]="loading()" mask="9999-99" />
      @if (paymentForm.get('reference_month')?.dirty && paymentForm.get('reference_month')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Competência é obrigatório</p-message>
      }
    </div>

    <div class="flex flex-col justify-start gap-1 col-span-2 md:col-span-1">
      <label for="type" class="font-semibold">Tipo</label>
      <p-select id="type" [options]="paymentType | keyvalue" formControlName="type" optionLabel="value"
        [showClear]="true" placeholder="Escolha um tipo" optionValue="value"
        [invalid]="paymentForm.get('type')?.dirty && paymentForm.get('type')?.errors" appendTo="body"
        [disabled]="loading()">
        <ng-template let-type #item>
          <div>{{ type.value | paymentType }}</div>
        </ng-template>
        <ng-template let-type #selectedItem>
          <div>{{ type.value | paymentType }}</div>
        </ng-template>
      </p-select>
      @if (paymentForm.get('type')?.dirty && paymentForm.get('type')!.hasError('required')) {
      <p-message severity="error" variant="simple" size="small">Selecione um tipo</p-message>
      }
    </div>

    @if (status === paymentStatus.PAID) {
    <div class="flex flex-col justify-start gap-1 col-span-1">
      <label for="paid_at" class="font-semibold">Data do Pagamento</label>
      <p-datepicker formControlName="paid_at" dateFormat="dd/mm/yy" [iconDisplay]="'input'" [showIcon]="true"
        inputId="paid_at" appendTo="body" fluid
        [invalid]="paymentForm.get('paid_at')?.dirty && paymentForm.get('paid_at')?.errors" />
    </div>
    }
  </form>

  <ng-template #footer>
    <p-button [label]="paymentId ? 'Fechar' : 'Cancelar'" [loading]="loading()" [text]="true" severity="secondary"
      (click)="closeDialog(); $event.stopPropagation()" />
    @if (!paymentId) {
    <p-button label="Salvar" [loading]="loading()" (click)="submitDialog()" />
    }
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="paymentConfirmDialog" [maximizable]="false" [modal]="true" [style]="{ width: '44rem' }"
  [closable]="true">
  <ng-template #header>
    <div class="w-full items-center justify-center">
      @if (paymentConfirmType === 'warning') {
      <h1 class="text-2xl text-zinc-900 font-bold">
        Atenção: Possível duplicidade detectada
      </h1>
      } @else if (paymentConfirmType === 'error') {
      <h1 class="text-2xl text-zinc-900 font-bold">
        Erro: Pagamento duplicado
      </h1>
      }
    </div>
  </ng-template>

  <div class="flex flex-col gap-4">
    <span class="text-lg text-zinc-700 font-semibold">
      @if (paymentConfirmType === 'warning') {
      <span class="text-amber-600">Atenção: </span>
      } @else if (paymentConfirmType === 'error') {
      <span class="text-rose-600">Erro: </span>
      }
      Já existe(m) pagamento(s) cadastrado(s) com os mesmos dados
    </span>

    <p-divider />

    <div class="flex flex-col gap-2 divide-y divide-gray-400">
      @for (data of paymentConfirmData; track $index) {
      <div class="flex flex-col items-start justify-start gap-2 pb-2">
        <div class="text-zinc-700"><span class="font-semibold">Documento:</span> {{ data.nfse_key }}</div>
        <div class="text-zinc-700"><span class="font-semibold">Valor:</span> {{ data.value | currency }}</div>
        <div class="text-zinc-700"><span class="font-semibold">Vencimento:</span> {{ data.due_date | date: 'd/M/y' }}
        </div>
        <div class="text-zinc-700"><span class="font-semibold">Status:</span> {{ data.status | paymentStatus }}</div>
      </div>
      }
    </div>
  </div>

  <p-divider />

  <ng-template #footer>
    <p-button label="Cancelar" [loading]="loading()" [text]="true" severity="secondary"
      (click)="closeConfirmDialog(); $event.stopPropagation()" />
    @if (paymentConfirmType === 'warning') {
    <p-button label="Confirmar" [loading]="loading()" (click)="submitDialog(true); closeConfirmDialog()" />
    }
  </ng-template>
</p-dialog>
